import React from "react";

import { TableContext } from "./TableContext";

const useTableCtx = () => React.useContext(TableContext);

export default useTableCtx;
